// extracted by mini-css-extract-plugin
export var archiveButtonColor = "dUEgS";
export var archiveIconHoverColor = "iltCw";
export var deleteButtonColor = "NLjWA";
export var deleteIconHoverColor = "QYwso";
export var mailListItemIsPinned = "s1De5";
export var markAsReadButtonColor = "ssAKK";
export var markAsReadIconHoverColor = "R_Gs1";
export var moveButtonColor = "XeV7I";
export var moveIconHoverColor = "pS604";
export var pinButtonColor = "iW_V0";
export var pinButtonFilledColor = "E3w8P";
export var pinFilledColor = "MWwjW";
export var pinIconColor = "xLIlX";
export var visibilityHidden = "hLBV6";